import React, { useState, useEffect } from 'react';
import { Menu, MenuItem, MenuButton, Flex, Card, Text, Button } from '@aws-amplify/ui-react';

import { fetchUserAttributes } from 'aws-amplify/auth';

function WebPageHeader({ onSignOut, currentPage, onPageChange, onToggleSidebar, sidebarOpen }) {
    const [userName, setUserName] = useState('');

    useEffect(() => {
        async function fetchUserName() {
            try {
                const user = await fetchUserAttributes();
                setUserName(user.name);
            } catch (error) {
                console.log('Error fetching user name:', error);
            }
        }

        fetchUserName();
    }, []);

    const style = {
        background: '#141F2E',
        padding: '0.75rem'
    };

    return (
        <Card style={style}>
            <Flex
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                wrap="nowrap"
                gap="1rem"
            >
                <Flex alignItems="center" gap="1rem">
                    {currentPage === 'meetings' && onToggleSidebar && (
                        <Button
                            size="small"
                            variation="link"
                            onClick={onToggleSidebar}
                            style={{ color: 'white', padding: '0.5rem', minWidth: 'auto' }}
                            title={sidebarOpen ? 'Hide sidebar' : 'Show sidebar'}
                        >
                            {sidebarOpen ? '◀' : '▶'}
                        </Button>
                    )}
                    <Text color="white" fontSize="1.2rem" fontWeight="bold">
                        Meeting Notes AI
                    </Text>
                    <Button
                        size="small"
                        variation={currentPage === 'meetings' ? 'primary' : 'link'}
                        onClick={() => onPageChange('meetings')}
                        style={{ color: 'white', border: '1px solid white' }}
                    >
                        Meetings
                    </Button>
                    <Button
                        size="small"
                        variation={currentPage === 'insights' ? 'primary' : 'link'}
                        onClick={() => onPageChange('insights')}
                        style={{ color: 'white', border: '1px solid white' }}
                    >
                        AI Insights
                    </Button>

                </Flex>
                
                <Menu
                    menuAlign="end"
                    size="small"
                    trigger={
                        <MenuButton
                            variation="link"
                            color="white"
                            backgroundColor="transparent"
                            border="1px solid white"
                            _hover={{ backgroundColor: "rgba(255,255,255,0.1)" }}
                        >
                            ☰
                        </MenuButton>
                    }
                >
                    <MenuItem onClick={() => alert('Show profile')}>
                        {userName} profile
                    </MenuItem>
                    <MenuItem onClick={onSignOut}>
                        Sign out
                    </MenuItem>
                </Menu>
            </Flex>
        </Card>
    );
}

export default WebPageHeader;
